import NativeMethodsMixin from "../NativeMethodsMixin";

var applyNativeMethods = function applyNativeMethods(Component) {
  Object.keys(NativeMethodsMixin).forEach(function (method) {
    if (!Component.prototype[method]) {
      Component.prototype[method] = NativeMethodsMixin[method];
    }
  });
  return Component;
};

export default applyNativeMethods;